import { useDispatch, useSelector } from 'react-redux';
import {
  activeDraftSuggestionSelector,
  selectCustomerDetailSelector,
} from 'redux/selectors';
import { useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import { loggedInUserSelector } from 'redux/selectors';

import { showSnackbar } from 'components/snackbar/actions';
import { api } from 'api';
import {
  addProductAndQuantityToDraft,
  updateProductQuantityDraft,
  removeGridItemToActiveDraft,
  updateItemSingleSuggestion,
  updateProductQuantityModalCall,
} from 'pages/catalog/action';
import { useURLSearchParams } from 'common-hooks/url-params-listener-hooks';
import {
  syncOrderDataOnClickHouse,
  syncReportData,
  updateOrderOnElasticAction,
} from 'pages/orders/actions';
import { clientIds } from 'constants';

export function useCrudOperationCart({
  setCartActionLoader = () => {},
  setCartFlag = () => {},
  setSuggestionActionLoader = () => {},
  setSuggestionFlag = () => {},
}) {
  const dispatch = useDispatch();
  const { cl } = useURLSearchParams();
  const activeDraftSuggestion = useSelector(activeDraftSuggestionSelector);
  const userInfo = useSelector(loggedInUserSelector);
  let currentPath = window.location.pathname.split('/');
  const { id } = useParams();
  const queryClient = useQueryClient();
  const clientInfo = useSelector(selectCustomerDetailSelector);
  let logobrandsClient = clientInfo?.id == clientIds?.logoBrands ? true : false;
  // =======================> Update Order On Elastic in Order Detail Page <====================
  const updateOrderOnElastic = async () => {
    try {
      if (userInfo?.report_clickhouse_synching) {
        await dispatch(
          syncReportData({
            type: 'order',
            buyer_id: null,
            worksheet_collection_id: parseInt(currentPath[2]),
          })
        );
      }
      if (userInfo?.elastic_syncing) {
        await dispatch(
          updateOrderOnElasticAction({
            worksheetCollectionId: parseInt(currentPath[2]),
          })
        );
      }
      if (userInfo?.order_clickhouse_synching) {
        await dispatch(
          syncOrderDataOnClickHouse({
            worksheetCollectionId: parseInt(currentPath[2]),
          })
        );
      }
    } catch (err) {
      console.error(err);
    }
  };
  // ====================> Add To Cart <==============================
  const addToCart = async (payload) => {
    setCartActionLoader(true);
    let prepack_quantity = {};
    let sizewise_quantity = {};
    for (let key in payload.values) {
      if (key.split('|')[1]) {
        if (logobrandsClient) {
          if (key.split('_')[1] !== 'units') {
            prepack_quantity[key] =
              payload?.values[key] == 1 && payload?.isBrokenPack
                ? 0
                : payload.values[key];
          }
        } else {
          prepack_quantity[key] = payload.values[key];
        }
      } else {
        sizewise_quantity[key] = payload.values[key];
      }
    }
    let updatedPayload = {};
    if (logobrandsClient) {
      updatedPayload = {
        item_id: payload.id,
        worksheet_collection_id:
          currentPath[1] === 'drafts'
            ? parseInt(currentPath[2])
            : parseInt(activeDraftSuggestion.draft.id),
        prepack_quantity,
        sizewise_quantity,
        shop_collection_id: payload.collection_id
          ? payload.collection_id
          : parseInt(cl),
        addtional_quantity: payload?.addtional_quantity,
      };
    } else {
      updatedPayload = {
        item_id: payload.id,
        worksheet_collection_id:
          currentPath[1] === 'drafts'
            ? parseInt(currentPath[2])
            : parseInt(activeDraftSuggestion.draft.id),
        prepack_quantity,
        sizewise_quantity,
        shop_collection_id: payload.collection_id
          ? payload.collection_id
          : parseInt(cl),
      };
    }

    if (currentPath.some((x) => x === 'order-payment')) {
      updatedPayload = {
        item_id: payload.id,
        worksheet_collection_id: parseInt(currentPath[2]),
        id: payload.id,
        collection_id: payload.collection_id,
        prepack_quantity,
        sizewise_quantity,
        is_order: true,
        prepack_order_quantity: payload.values.prepack_order_quantity,
      };
    }
    if (currentPath.some((x) => x === 'suggestions')) {
      updatedPayload = {
        item_id: payload.id,
        worksheet_collection_id: parseInt(activeDraftSuggestion.draft.id),
        linesheet_id: parseInt(id),
        prepack_quantity,
        sizewise_quantity,
        shop_collection_id: payload.collection_id
          ? payload.collection_id
          : parseInt(cl),
      };
    }
    if (currentPath.some((x) => x === 'customization')) {
      updatedPayload = {
        item_id: payload.id,
        worksheet_collection_id: parseInt(
          activeDraftSuggestion?.customized_draft?.id
        ),
        shop_collection_id: '-1',
        product_customization_id: payload?.customizer_id,
      };
    }
    const res = await dispatch(
      addProductAndQuantityToDraft({ ...updatedPayload })
    );
    if (currentPath.some((x) => x === 'order-payment')) {
      if (res?.data?.status) {
        updateOrderOnElastic();
      }
    }
    if (!res?.data?.status) {
      setCartFlag(false);
      dispatch(
        showSnackbar({
          snackbarMessage: 'Unable to add this Product',
          type: 'error',
          snackbarAlign: {
            vertical: 'top',
            horizontal: 'center',
          },
        })
      );
    }
    setCartActionLoader(false);
    return res;
  };
  // ====================> Update Product Quantity <=======================
  const updateProductQuantity = async (payload) => {
    const updatedPayload = {
      ...payload,
      worksheet_collection_id: parseInt(activeDraftSuggestion.draft.id),
      warehouse_id: '',
      is_order: false,
    };

    const res = await dispatch(
      updateProductQuantityDraft({ ...updatedPayload })
    );

    if (res?.data?.status) {
      // console.log('success');
    }
  };
  // ===================> Remove From Cart <===========================
  const removeFromCart = async (payload, action = '') => {
    setCartActionLoader(true);
    let updatedPayload = {
      ...payload,
      worksheet_collection_id: activeDraftSuggestion.draft.id,
    };
    if (currentPath.some((x) => x === 'suggestions')) {
      updatedPayload = {
        ...payload,
        worksheet_collection_id: activeDraftSuggestion.draft.id,
        linesheet_id: parseInt(id),
      };
    }
    if (!isEmpty(action)) {
      updatedPayload.action = action;
    }
    const data = await dispatch(removeGridItemToActiveDraft(updatedPayload));
    if (!data?.status) {
      setCartFlag(true);
      dispatch(
        showSnackbar({
          snackbarMessage: 'Unable to remove this itme from cart',
          type: 'error',
          snackbarAlign: {
            vertical: 'top',
            horizontal: 'right',
          },
        })
      );
    }
    setCartActionLoader(false);
    return data;
  };
  const addToCartPrePack = async (payload) => {
    let prepack_quantity = {};
    let sizewise_quantity = {};

    for (let key in payload.values) {
      if (key.split('|')[1]) {
        if (key.split('_')[1] !== 'units') {
          prepack_quantity[key] =
            payload?.values[key] == 1 && payload?.isBrokenPack
              ? 0
              : payload.values[key];
        }
      } else {
        sizewise_quantity[key] = payload.values[key];
      }
    }
    let updatedPayload = {
      item_id: payload.id,
      worksheet_collection_id: parseInt(activeDraftSuggestion.draft.id),
      prepack_quantity,
      sizewise_quantity,
      shop_collection_id: payload.collection_id
        ? payload.collection_id
        : parseInt(cl),
      addtional_quantity: payload?.addtional_quantity,
    };
    const res = await dispatch(
      addProductAndQuantityToDraft({ ...updatedPayload })
    );
  };
  // ===================> SUBMIT FORM <====================================
  function submit({
    productId,
    colorId,
    product_quantity,
    addtional_quantity,
  }) {
    if (productId) {
      if (logobrandsClient) {
        updateProductQuantity({
          product_id: parseInt(productId),
          product_color_id: parseInt(colorId),
          product_quantity: product_quantity,
          addtional_quantity: addtional_quantity,
        });
      } else {
        updateProductQuantity({
          product_id: parseInt(productId),
          product_color_id: parseInt(colorId),
          product_quantity: product_quantity,
        });
      }
    }
  }
  //======================> update Suggestion <============================
  const modifyItemSingleSuggestion = async (payload) => {
    setSuggestionActionLoader(true);
    if (!activeDraftSuggestion.suggestion.id) {
      dispatch(
        showSnackbar({
          snackbarMessage:
            'No suggestion selected. Please select or create a suggestion',
          type: 'error',
          snackbarAlign: {
            vertical: 'top',
            horizontal: 'right',
          },
        })
      );
      return;
    }

    const updatedPayload = {
      ...payload,
      lineSheetId: activeDraftSuggestion.suggestion.id,
    };

    const data = await dispatch(
      updateItemSingleSuggestion(updatedPayload, queryClient)
    );
    if (data && data.message !== 'Success') {
      setSuggestionFlag(updatedPayload.isSuggest === 1 ? false : true); // checking if user tried to add suggestion and it got failed so make it false
      dispatch(
        showSnackbar({
          snackbarMessage: 'Unable to Add This Suggestion',
          type: 'error',
          snackbarAlign: {
            vertical: 'top',
            horizontal: 'right',
          },
        })
      );
    }
    setSuggestionActionLoader(false);
  };
  // =========================> Update Products for Modal <=========================

  const updateProductFromModal = async (payload, draftOrder) => {
    setCartActionLoader(true);

    const updatedPayload = {
      ...payload,
      action: 'update',
      // type: 'add_item_to_worksheet',
    };
    let currentPath = window.location.pathname.split('/');
    updatedPayload.worksheet_collection_id = currentPath.some(
      (x) => x === 'order-payment'
    )
      ? parseInt(currentPath[2])
      : activeDraftSuggestion.draft.id;
    /*updatedPayload.worksheet_collection_id = parseInt(
      activeDraftSuggestion.draft.id
    );*/

    const res = await dispatch(
      updateProductQuantityModalCall({ ...updatedPayload })
    );
    setCartActionLoader(false);
    return res;
  };

  //remove product from order
  const removeProduct = async (productId, selectedWorksheet, callback) => {
    const res = await api.post(`/removeItemFromDraft`, {
      item_id: productId,
      worksheet_id: selectedWorksheet?.worksheetCollectionId,
      is_order: true,
      replenish_inv: false,
    });

    if (res?.data?.status) {
      if (callback) {
        callback({ showLoader: true });
      }
    }

    return res;
  };

  return {
    addToCart,
    submit,
    removeFromCart,
    updateProductQuantity,
    modifyItemSingleSuggestion,
    updateProductFromModal,
    removeProduct,
    addToCartPrePack,
  };
}
